import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Tooltip
} from "@mui/material";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useSelector } from "react-redux";
import { FETCH_PROJECTS_COMPANIES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AddCompanyWithRole from "../common/AddCompanyWithRole";
import ErrorIcon from "@mui/icons-material/Error";
import { BIBlue } from "../../assets/helpers";
import AddRoleToCompanyModal from "./AddRoleToCompanyModal";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import Pages from "../../constant/ReportModel";

function ProjectCompanySection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const {
    TEXT_ADD_COMPANY = English?.ProjectCompaniesSection?.TEXT_ADD_COMPANY,
    TEXT_PROJECT_NO_INFORMATION = English?.ProjectCompaniesSection?.TEXT_PROJECT_NO_INFORMATION,
    TEXT_NO_DATA_INFO_SUBTEXT = English?.ProjectCompaniesSection?.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_SEARCH_THIS_PROJECT_COMPANIES = English?.ProjectCompaniesSection
      ?.TEXT_SEARCH_THIS_PROJECT_COMPANIES,
    BUTTON_ADD_COMPANY_ROLE_ON_PROJECT = English?.ProjectCompaniesSection
      ?.BUTTON_ADD_COMPANY_ROLE_ON_PROJECT,
    BUTTON_REPORT = English?.ProjectCompaniesSection?.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = English?.ProjectCompaniesSection?.TEXT_NO_RESULTS_FOUND,
    TEXT_ADD_COMPANY_TO_PROJECT = English?.ProjectCompaniesSection?.TEXT_ADD_COMPANY_TO_PROJECT,
    TEXT_ADD_ROLE_TO_A_COMPANY = English?.ProjectCompaniesSection?.TEXT_ADD_ROLE_TO_A_COMPANY,
    BUTTON_OK = English?.ProjectCompaniesSection?.BUTTON_OK,
    TEXT_NO_ROLE = English?.ProjectCompaniesSection?.TEXT_NO_ROLE
  } = multiLanguageData?.ProjectCompaniesSection || {};
  const debounceTimeout = useRef(null);
  const [companyData, setCompanyData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);
  const [showAddRoleModal, setShowAddRoleModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    setIsLoading(true);
    await getCompanyData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getCompanyData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ projectId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };
      const res = await Postrequestcall(FETCH_PROJECTS_COMPANIES, obj, loginData?.accessToken);
      let resData =
        res?.data?.data?.sort((a, b) => a?.companyName?.localeCompare(b?.companyName)) ?? [];

      const groupedData = resData.reduce((acc, item) => {
        const key =
          item?.projectCompanyRoleId === 0 || item?.projectCompanyRole?.trim() === ""
            ? "No Role"
            : item?.projectCompanyRole;

        if (!acc[key]) {
          acc[key] = {
            projectCompanyRoleId: item?.projectCompanyRoleId,
            projectCompanyRole:
              item?.projectCompanyRoleId === 0 || item?.projectCompanyRole?.trim() === ""
                ? "No Role"
                : item?.projectCompanyRole,
            items: []
          };
        }

        acc[key].items.push(item);
        return acc;
      }, {});

      let groupData = Object.values(groupedData);
      const noRoleData = groupData.find((group) => group?.projectCompanyRole === "No Role");
      if (noRoleData) {
        groupData = groupData.filter((group) => group?.projectCompanyRole !== "No Role");
        groupData.push(noRoleData); // Add "No Role" group at the end
      }

      if (pageNumber > 1) {
        setTimeout(() => {
          setCompanyData((prevProducts) => [...prevProducts, ...groupData]);
        }, 500);
      } else {
        setCompanyData(() => groupData);
        if (fristTimeApiCall) {
          setHasData(groupData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getCompanyData-> Error While Fetching Project Company:  ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: selectedItemDetails.id ?? 0,
      name: Pages?.productCompanies?.name,
      AppScreenId: Pages?.productCompanies?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const handleRoleModal = () => {
    setMoreMenuAnchorEl(null);
    setShowAddRoleModal(true);
  };

  const onAddCompanyClick = () => {
    setShowAddCompanyModal(true);
  };

  const onItemClick = (item) => {
    const isMfr =
      item?.manufacturer === true ||
      String(item?.manufacturer).toLowerCase() === "true" ||
      item?.manufacturer === 1 ||
      String(item?.isManufacturer).toLowerCase() === "true" ||
      item?.isManufacturer === true;

    const targetId = item?.companyId;
    if (!targetId) return;

    if (isMfr) {
      navigate(`/manufacture/${targetId}`);
    } else {
      navigate(`/company/${targetId}`);
    }
  };

  const onRoleSave = async () => {
    setShowAddRoleModal(false);
    setSelectedItemDetails(false);
    setIsLoading(true);
    await getCompanyData(searchTerm, 1, "fristTimeApiCall");
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddCompanyClick}>
          {TEXT_ADD_COMPANY}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BusinessCenterIcon className="emptydata-icon" />}
            firstText={TEXT_PROJECT_NO_INFORMATION}
            secondText={TEXT_NO_DATA_INFO_SUBTEXT}
          />
        </Box>
      </Stack>
    );
  };

  const onCompanyClick = (currentTarget, company) => {
    setSelectedItemDetails(company);
    setMoreMenuAnchorEl(currentTarget);
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <SearchField
          placeholder={TEXT_SEARCH_THIS_PROJECT_COMPANIES}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getCompanyData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getCompanyData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddCompanyClick}>
          {TEXT_ADD_COMPANY}
        </Button>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : companyData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={companyData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getCompanyData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  {companyData.map((item) => (
                    <Box key={item?.id}>
                      <ListSubheader
                        key={`subheader-${item?.manufacturerId}`}
                        sx={{ pl: 0.5, cursor: "pointer" }}>
                        {item?.projectCompanyRole === "No Role"
                          ? TEXT_NO_ROLE
                          : item?.projectCompanyRole}
                        {item?.projectCompanyRole === "No Role" &&
                          item?.projectCompanyRoleId === 0 && (
                            <IconButton
                              onClick={() => {
                                setShowMessage(true);
                              }}
                              style={{ marginTop: "-5px" }}>
                              <ErrorIcon sx={{ width: 15, height: 15 }} />
                            </IconButton>
                          )}
                      </ListSubheader>
                      <Stack spacing={1}>
                        {item?.items?.map((company) => (
                          <Card
                            key={company?.id ?? `${company?.companyName}-${Math.random()}`}
                            className="pagelist-content">
                            <ListItem
                              style={{ padding: "0px" }}
                              secondaryAction={
                                <IconButton
                                  onClick={(event) => onCompanyClick(event.currentTarget, company)}>
                                  <MoreIcon />
                                </IconButton>
                              }>
                              <ListItemButton
                                onClick={() => {
                                  onItemClick(company);
                                }}>
                                <ListItemText
                                  primary={
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                      {company?.companyName}
                                      {company?.verified && (
                                        <Tooltip title="This company has been verified" arrow>
                                          <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                                        </Tooltip>
                                      )}
                                    </Box>
                                  }
                                />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </Box>
                  ))}
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => {
                    setSelectedItemDetails(null);
                    setMoreMenuAnchorEl(null);
                  }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  {selectedItemDetails?.projectCompanyRoleId === 0 ||
                  selectedItemDetails?.projectCompanyRole?.trim() === "" ? (
                    <MenuItem
                      onClick={() => {
                        handleRoleModal();
                      }}
                      dense
                      style={{ color: BIBlue }}>
                      {BUTTON_ADD_COMPANY_ROLE_ON_PROJECT}
                    </MenuItem>
                  ) : (
                    <></>
                  )}
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}

        {showAddCompanyModal && (
          <AddCompanyWithRole
            open={showAddCompanyModal}
            onClose={() => {
              setShowAddCompanyModal(false);
            }}
            from="project"
            title={TEXT_ADD_COMPANY_TO_PROJECT}
            mainId={id}
            onDataSave={async () => {
              setShowAddCompanyModal(false);
              await getInitialData();
            }}
          />
        )}

        {showMessage && (
          <Modal
            open={showMessage}
            onClose={() => {
              setShowMessage(false);
            }}>
            <div className="modal-center">
              <div className="modal-card" style={{ width: "400px" }}>
                <div className="modal-card-body">
                  <div className="flex-container-verticle">
                    <p>{TEXT_ADD_ROLE_TO_A_COMPANY}</p>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        color="primary"
                        onClick={() => {
                          setShowMessage(false);
                        }}>
                        {BUTTON_OK}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}

        {showAddRoleModal && (
          <AddRoleToCompanyModal
            open={showAddRoleModal}
            onClose={() => {
              setShowAddRoleModal(false);
              setSelectedItemDetails(false);
            }}
            data={selectedItemDetails}
            onDataSave={onRoleSave}
          />
        )}
      </Card>
    </Box>
  );
}

export default ProjectCompanySection;

